const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);

export function sanitizeExternalUrl(rawUrl, context = 'external link') {
  if (typeof rawUrl !== 'string') return null;
  const trimmed = rawUrl.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('/')) {
    console.error(`[links] blocked ${context} relative URL:`, trimmed);
    return null;
  }

  const hasScheme = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed);
  const candidate = hasScheme ? trimmed : `https://${trimmed}`;

  try {
    const parsed = new URL(candidate);
    if (!ALLOWED_PROTOCOLS.has(parsed.protocol)) {
      console.error(`[links] blocked ${context} URL with protocol ${parsed.protocol}:`, trimmed);
      return null;
    }
    return parsed.toString();
  } catch (error) {
    console.error(`[links] invalid ${context} URL:`, trimmed, error);
    return null;
  }
}
